import { EmoticonCoolIcon } from './EmoticonCoolIcon';

/**
 * author: Michael Irigoyen
 * id 77FAFB8C-4322-4A18-8E92-0CE311F775D3
 * name emoticon-cool
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-cool.svg
 * tags
 * - Emoji 
 */
export const EmojiCoolIcon = EmoticonCoolIcon;
export default EmojiCoolIcon